import axios from "axios";
import * as d3 from "d3";
import {axisTextDim1, colonAnnotation, numberFormat, responsivefy, XaxisAttribute} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = (chart.axisLabelFontSize - 10) + "px"
    //var tempVar = chart.tempVar

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    axios.post(url, filterParam).then(res => {
        let data = res.data;

        // append the svg object to the body of the page
        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append('svg')
            .attr('width', chart.width - chart.margin.left + chart.margin.right)
            .attr('height', chart.height + 2 * chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append('g')
            .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

        // Build scales x-axis and y-axis
        var x1Scale = d3.scaleBand().rangeRound([0, chart.width]).padding(0.01)
        var y1Scale = d3.scaleBand().rangeRound([chart.height, 0]).padding(0.02)
        //calling scales
        var x1AxisLabel = d3.axisBottom().scale(x1Scale)
        var y1AxisLabel = d3.axisLeft().scale(y1Scale)
        // Build color scales
        var metric1ColorScale = d3.scaleLinear()
            .range(["red", "green"])
            .domain([d3.min(data, (d) => {
                return d.metric1
            }),
                d3.max(data, (d) => {
                    return d.metric1
                })
            ]);

        // Labels of row and columns
        x1Scale.domain(data.map((d) => {
            return d.dim1_name
        }).sort(d3.ascending))
        y1Scale.domain(data.map((d) => {
            return d.dim2_name
        }))

        svg.append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .call(x1AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style('text-anchor', 'start')
            .attr('dx', XaxisAttribute)
            .attr('transform', 'rotate(-50)')
            .text(axisTextDim1)

        svg.append('g')
            .attr('class', 'y axis')
            .call(y1AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style('text-anchor', 'start')
            .attr('dx', XaxisAttribute)
            .text(axisTextDim1)

        var lable = data.map(function (d) {
            return d.lable
        });
        svg.append("g")
            .append("text")
            .text(lable[0])
            .attr('fill', '#4000ff')
            .attr('font-size', '35px')
            .attr("class", "title")
            .attr("x", -chart.margin.left)
            .attr("y", -20);

        svg.append('text')
            .attr('x', (chart.width / 3))
            .attr('y', chart.height + chart.margin.bottom + 2 * chart.axisLabelDistance)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left + 4 * chart.axisLabelDistance)
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', fontSize)

        // create a tooltip
        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element
            var y1tip = tooltip_class()

            y1tip.attr('class', 'd3-tip'+divId.id)
                .html((d) =>{
                    return d.dim1_name+ colonAnnotation+ d.dim2_name+ colonAnnotation+ numberFormat(d.metric1)
                })

            svg.call(y1tip);*/

        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;')

        // add the squares
        svg.selectAll()
            .data(data, (d) => {
                return d.dim1_name + ':' + d.dim2_name
            })
            .enter().append('rect')
            .attr('x', (d) => {
                return x1Scale(d.dim1_name)
            })
            .attr('y', (d) => {
                return y1Scale(d.dim2_name)
            })
            .attr('width', x1Scale.bandwidth())
            .attr('height', y1Scale.bandwidth())
            .style('fill', (d) => {
                return metric1ColorScale(d.metric1)
            })
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(d.dim1_name + colonAnnotation + d.dim2_name + colonAnnotation + numberFormat(d.metric1))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            })
        //.on("mouseover", y1tip.show)
        //.on("mouseout", y1tip.hide)
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding
    })
}
